// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file shifts/shift_summary.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { SalesInShift, ShiftDetails } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ShiftSummaryRequest
 */
export class ShiftSummaryRequest extends Message<ShiftSummaryRequest> {
  /**
   * @generated from field: string shift_id = 1;
   */
  shiftId = "";

  constructor(data?: PartialMessage<ShiftSummaryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ShiftSummaryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "shift_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ShiftSummaryRequest {
    return new ShiftSummaryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ShiftSummaryRequest {
    return new ShiftSummaryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ShiftSummaryRequest {
    return new ShiftSummaryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ShiftSummaryRequest | PlainMessage<ShiftSummaryRequest> | undefined, b: ShiftSummaryRequest | PlainMessage<ShiftSummaryRequest> | undefined): boolean {
    return proto3.util.equals(ShiftSummaryRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ShiftSummaryResponse
 */
export class ShiftSummaryResponse extends Message<ShiftSummaryResponse> {
  /**
   * @generated from field: com.neulink.pharmacy.ShiftDetails shift_details = 1;
   */
  shiftDetails?: ShiftDetails;

  /**
   * @generated from field: float total_cash_collected = 2;
   */
  totalCashCollected = 0;

  /**
   * @generated from field: float total_card_collected = 3;
   */
  totalCardCollected = 0;

  /**
   * @generated from field: float total_insurance_billed = 4;
   */
  totalInsuranceBilled = 0;

  /**
   * @generated from field: float total_revenue_collected = 5;
   */
  totalRevenueCollected = 0;

  /**
   * @generated from field: repeated com.neulink.pharmacy.SalesInShift sales_in_shift = 6;
   */
  salesInShift: SalesInShift[] = [];

  constructor(data?: PartialMessage<ShiftSummaryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ShiftSummaryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "shift_details", kind: "message", T: ShiftDetails },
    { no: 2, name: "total_cash_collected", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "total_card_collected", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "total_insurance_billed", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "total_revenue_collected", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "sales_in_shift", kind: "message", T: SalesInShift, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ShiftSummaryResponse {
    return new ShiftSummaryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ShiftSummaryResponse {
    return new ShiftSummaryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ShiftSummaryResponse {
    return new ShiftSummaryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ShiftSummaryResponse | PlainMessage<ShiftSummaryResponse> | undefined, b: ShiftSummaryResponse | PlainMessage<ShiftSummaryResponse> | undefined): boolean {
    return proto3.util.equals(ShiftSummaryResponse, a, b);
  }
}

